import React, { useState, useEffect } from 'react'
import { Layout } from 'antd'
import { ProjectRoutes } from './components/ProjectRoutes'
import { NavHeader } from './components/NavHeader'
import { DevSideNav } from './components/DevSideNav'
import './index.css'
import { useQueryParams } from 'hooks/useQueryParams'
import { useLocation } from 'react-router-dom'
import { cimsStorage } from '../utils/storage'
import ProjectSideNav from './components/ProjectSideNav'
import { DevRoutes } from './components/DevRoutes'
import { ProjectProvider } from 'context/ProjectContext'
import { useRouteMatches } from 'hooks/useRouteMatches'

export const App: React.FC = () => {
  const { pathname } = useLocation()
  const { collapseNav } = useQueryParams()
  const [collapsed, setCollapsed] = useState(false)
  const { param } = useRouteMatches()
  const projectId = param('projectId')

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    if (collapseNav === 'true') setCollapsed(true)
  }, [collapseNav])

  useEffect(() => {
    // don't need to store Login page
    if (pathname !== '/')
      cimsStorage.setPath(
        // Normalize projectId to lowercase before storing path in localStorage
        projectId
          ? pathname.replace(projectId, projectId.toLowerCase())
          : pathname
      )
  }, [pathname, projectId])

  const AppLayout: React.VFC<{ routes: React.VFC }> = ({ routes }) => (
    <Layout style={{ background: '#fff', overflowY: 'auto' }}>
      <NavHeader collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout.Content style={{ padding: '32px' }}>{routes({})}</Layout.Content>
    </Layout>
  )

  return (
    <Layout style={{ height: '100vh', width: '100vw', overflowY: 'auto' }}>
      {projectId ? (
        <ProjectProvider>
          <ProjectSideNav collapsed={collapsed} />
          <AppLayout routes={ProjectRoutes} />
        </ProjectProvider>
      ) : (
        <>
          <DevSideNav collapsed={collapsed} />
          <AppLayout routes={DevRoutes} />
        </>
      )}
    </Layout>
  )
}
